import PodcastTitle from './PodcastTitle';

export default PodcastTitle;
